module.exports = __webpack_public_path__ + "static/media/gr.bcaf3605.svg";